<template>
    <textarea id='text_area' v-model="text" :placeholder=placeholder></textarea>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'textEdit',
  props: {
    'placeholder': String
  },
  data () {
    return {
      text: '',
      activation_failed_count: 0
    }
  },
  mounted () {
    this.initContent()
  },
  methods: {
    initContent () {
      Vue.nextTick(tick => {
        if (document.getElementById('text_area')) {
          this.activateEditor()
        } else {
          console.log('text_area not found, waiting before activating editor')
          this.activation_failed_count += 1
          if (this.activation_failed_count < 10) {
            this.initContent()
          }
        }
      })
    },
    activateEditor () {
      console.log('activating editor')
      if (!window.CKEDITOR) {
        console.error('Please include CKEditor in your page')
        return
      }
      window.CKEDITOR.plugins.addExternal('smiley', '/static/js/ckeditor/plugins/smiley/', 'plugin.js')
      window.CKEDITOR.replace('text_area', {
        extraPlugins: 'smiley'
      })
    },
    getText () {
      return window.CKEDITOR.instances.text_area.getData()
    },
    setText (text) {
      window.CKEDITOR.instances.text_area.setData(text)
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// text-edit.vue?f4109a6e